import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Header.scss";
import Image from "../../../components/image/Image";
import { AppIcons } from "../../../data/appIcons";
import { logout } from '../../../app/slice/authSlice'

function Header() {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const user = authState?.user;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="header-section">
      <div className="left-section"></div>
      <div className="right-section">
        <div className="profile-section">
          <div className="profiles" ref={dropdownRef}>
            <div className="profile-toggle" onClick={toggleDropdown} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <div className="profile-img">
                <Image
                  imagePath={AppIcons.userIcon}
                  imgCustomClassName="open-bar"
                  altText="Icon"
                />
              </div>
              <div className="user-name-desc">
                <span className="name">{user?.userDisplayName || "Account"}</span>
                <span>
                  <Image
                    imagePath={AppIcons.arrowIcon}
                    imgCustomClassName="open-bar"
                    altText="Icon"
                  />
                </span>
              </div>
            </div>
            {dropdownOpen && (
              <div className="profile-dropdown-menu show">
                <div className="title-list">
                  <span className="name-title">Signed in as</span>
                  <span className="user-name">{user?.userDisplayName}</span>
                  <span className="user-email">{user?.userName}</span>
                </div>
                <div 
                  className="title-list drop-down-icon-menu logout-item" 
                  onClick={() => {
                    setDropdownOpen(false);
                    dispatch(logout());
                  }}
                  role="button"
                >
                  <i className="bi bi-box-arrow-left"></i>
                  <span>Log out</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
